import React from 'react';
import { Tag } from 'antd';
import { tagColors } from 'utils/constant';

const StatusTag = ({ tag, color = null }) => {
  const capitalizedTag = tag
    ?.split('_')
    ?.map((segment) => segment?.charAt(0)?.toUpperCase() + segment?.slice(1)?.toLowerCase())
    ?.join('_');
  const colorClass = color || tagColors[capitalizedTag?.toUpperCase()] || 'default';
  const className = `tag-${colorClass} rounded-md`;

  return <Tag className={className}>{capitalizedTag === 'Activation required' ? 'Activation Required' : capitalizedTag}</Tag>;
};

export default StatusTag;
